const TEAM = [
  {
    name: "Yehuda Shoshani",
    role: "CEO & Founder",
    img: "assets/imgs/Yehuda-Shoshani.jpg",
    linkedin: "https://www.linkedin.com/in/yehuda-shoshani-9b5963120/",
  },
  {
    name: "Stav Ben Simhon",
    role: "Cloud Solution Architect",
    img: "assets/imgs/Stav-Ben-Simhon.jpg",
    linkedin: "https://www.linkedin.com/in/stav-ben-simchon-46859a96/",
  },
  {
    name: "Itay Zrihan",
    role: "DevOps Tech Lead",
    img: "assets/imgs/Itay-Zrihan.jpg",
    linkedin: "https://www.linkedin.com/in/itay-zrihan-4573ab1ba/",
  },
  {
    name: "Yakir Bar",
    role: "DevOps Developer Expert",
    img: "assets/imgs/Yakir-Bar.jpg",
    linkedin: "https://www.linkedin.com/in/yakir-bar/",
  },
];

export default function Team() {
  return (
    <section id="team" className="section">
      <div className="container">
        <div className="section__head">
          <span className="section__eyebrow">The crew</span>
          <h2 className="section__title">Meet the engineers behind Dinghy</h2>
          <p className="section__lead">
            A senior team that&rsquo;s spent years operating production at scale -
            now focused full-time on shipping yours.
          </p>
        </div>

        <div className="team-grid">
          {TEAM.map((m) => (
            <article key={m.name} className="team-card">
              <div className="team-card__avatar">
                <img src={m.img} alt={m.name} />
              </div>
              <h3 className="team-card__name">{m.name}</h3>
              <p className="team-card__role">{m.role}</p>
              <a
                className="team-card__linkedin"
                href={m.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${m.name} on LinkedIn`}
              >
                <span className="mdi mdi-linkedin" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
